/**
 * MINE-CLEARANCE 游戏常量配置表
 * ==============================================
 * Author: Vicco Wang
 * Date: 2019/08/16
 */
export const baseSize = 600
 /**
  * 定义游戏等级
  * row col 表示 行和列的数量
  * mine 表示雷的数量
  */
 export const level = {
   easy: {
     row: 10,
     col: 10,
     mine: 20,
   },
   normal: {
     row: 14,
     col: 14,
     mine: 35,
   },
   hard: {
     row: 18,
     col: 18,
     mine: 50,
   },
  //  hell: {
  //    row: 24,
  //    col: 24,
  //    mine: 50
  //  }
}

/**
 * 
 * 
 * 
 */
export const prize = {
  easy: {
    score: 100
  },
  normal: {
    score: 400
  },
  hard: {
    score: 1000
  }
}


/**
 * 定义emoji对象
 */
export const emoji = {
  level: {
    image: '🌡️',
    desc: '难度',
  },
  stage: {
    1: {
      image: '😄',
      desc: '容易'
    },
    2: {
      image: '🤨',
      desc: '一般'
    },
    3: {
      image: '😈',
      desc: '困难'
    },
    4: {
      image: '💀',
      desc: '地狱'
    }
  },
  cursor: {
    image: '⛏️',
    desc: '撬'
  },
  playing: {
    image: '🎮',
    desc: '🕹️'
  },
  noPlay: {
    image: '🎮',
    desc: '🚬'
  },
  win: {
    image: '🎌',
    desc: '赢啦！'
  },
  lose: {
    image: '😨',
    desc: '踩到雷了！'
  },
  bomb: {
    image: '💣',
    // image: '⚽',
    desc: '地雷'
  },
  flag: {
    image: '⛳',
    // image: '🍉',
    desc: '标记'
  },
  time: {
    image: '⏱️',
    desc: '计时'
  }
}